import { render, staticRenderFns } from "./recom.vue?vue&type=template&id=fa2a4e68&scoped=true&"
import script from "./recom.vue?vue&type=script&lang=js&"
export * from "./recom.vue?vue&type=script&lang=js&"
import style0 from "./recom.vue?vue&type=style&index=0&id=fa2a4e68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2a4e68",
  null
  
)

export default component.exports